import React from 'react';

export const AppointmentIcon = ({ width = 24, height = 24, color = "#CCCCCC", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className={className}
                d="M6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.19667 21.0217 4.00067 20.5507 4 20V4C4 3.45 4.196 2.97933 4.588 2.588C4.98 2.19667 5.45067 2.00067 6 2H18C18.55 2 19.021 2.196 19.413 2.588C19.805 2.98 20.0007 3.45067 20 4V20C20 20.55 19.8043 21.021 19.413 21.413C19.0217 21.805 18.5507 22.0007 18 22H6ZM6 20H18V4H16V10.125C16 10.325 15.9167 10.471 15.75 10.563C15.5833 10.655 15.4167 10.6507 15.25 10.55L14.025 9.8C13.8583 9.7 13.6873 9.65 13.512 9.65C13.3367 9.65 13.166 9.7 13 9.8L11.775 10.55C11.6083 10.65 11.4377 10.6543 11.263 10.563C11.0883 10.4717 11.0007 10.3257 11 10.125V4H6V20ZM11.263 10.563C11.0883 10.4717 11.0007 10.3257 11 10.125C10.9993 10.3257 11.0877 10.4717 11.263 10.563Z"
                fill={color}
            />
        </svg>
    );
};
